














import { Vue, Prop, Component, Emit } from 'vue-property-decorator';

@Component
export default class Checkbox extends Vue {
  value: boolean = false;

  @Prop({ type: String, required: true })
  readonly name!: string;

  @Prop({ type: String, required: true })
  readonly label!: string;

  @Emit('checkboxChanged')
  checkboxChanged(): Object {
    return { ...this.$props, value: this.value };
  }
}
